import * as React from 'react';
import { styles } from './styles';

export const Spinner: React.SFC<{}> = () => <div className={styles.loader} />;
